type Props = {
  onBack?: () => void;
  backLabel?: string;
  backDisabled?: boolean;
  skipLabel?: string;
  onSkip?: () => void;
  skipDisabled?: boolean;
  primaryLabel: string;
  onPrimary: () => void;
  primaryDisabled?: boolean;
  secondaryLabel?: string;
  onSecondary?: () => void;
};

export function IntakeFooterNav({
  onBack,
  backLabel = "Back",
  backDisabled,
  skipLabel,
  onSkip,
  skipDisabled,
  primaryLabel,
  onPrimary,
  primaryDisabled,
  secondaryLabel,
  onSecondary,
}: Props) {
  return (
    <footer className="intake-footer">
      <div className="intake-footer__row">
        {onBack ? (
          <button
            type="button"
            className="intake-footer__link"
            disabled={backDisabled}
            onClick={onBack}
          >
            {backLabel}
          </button>
        ) : (
          <span />
        )}

        {skipLabel && onSkip ? (
          <button
            type="button"
            className="intake-footer__link intake-footer__link--center"
            disabled={skipDisabled}
            onClick={onSkip}
          >
            {skipLabel}
          </button>
        ) : (
          <span />
        )}

        <div className="intake-footer__actions">
          {secondaryLabel && onSecondary && (
            <button
              type="button"
              className="intake-footer__pill intake-footer__pill--secondary"
              onClick={onSecondary}
            >
              {secondaryLabel}
            </button>
          )}
          <button
            type="button"
            className="intake-footer__pill"
            disabled={primaryDisabled}
            onClick={onPrimary}
          >
            {primaryLabel}
          </button>
        </div>
      </div>
    </footer>
  );
}
